module.exports = __webpack_public_path__ + "fonts/KNFontYuanmo.ffaa60f2.otf";